<template>
  <div class="mainElemetManagementContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn">
          {{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i>
        </el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="flightRecordTableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
       <el-table-column
          v-for="recordItem in flightRecordTableColumnLists"
          :key="recordItem.prop"
          :prop="recordItem.prop"
          :label="recordItem.label"
          :min-width="recordItem.minWidth"
          :align="recordItem.align"
          :show-overflow-tooltip="recordItem.showOverflowTooltip"
        ></el-table-column>

        <el-table-column
          label="操作"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
                <el-button
                  @click="seeDetailHandle(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                >查看详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div
        style="text-align:right; margin-top:15px; margin-right:0px; height: 40px;"
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        />
      </div>
    </div>

    <!-- 查看详情 模态框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="594px"
      class="commonDialog"
      @close="closeDetailHandle"
    >
      <div class="flightRecordContent">
          <div class="planTitle">
            <div class="descOfNo">
              计划编号：<span>{{ singleFlightRecordData.local_id}} </span>
            </div>
            <div class="line"></div>
            <div class="otherPlanInfo">
              <span>创建时间：{{ singleFlightRecordData.created_at}}</span>
              <span>提交人：{{ singleFlightRecordData.user_name}}</span>
            </div>
          </div>

          <div class="recordContent">
            <div class="taskInfoBox">
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    开始时间: <span>{{ singleFlightRecordData.start_at }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    结束时间: <span>{{ singleFlightRecordData.end_at }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    实际开始时间: <span>{{ singleFlightRecordData.real_start_at }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    实际结束时间: <span>{{ singleFlightRecordData.real_end_at }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    计划飞行时间: <span>{{ singleFlightRecordData.plan_time + ' min' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    计划飞行速度: <span v-if="singleFlightRecordData.plan_speed">{{ singleFlightRecordData.plan_speed.toFixed(2) + ' km/h' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    实际飞行时间: <span>{{ singleFlightRecordData.real_time + ' min' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    实际飞行速度: <span>{{ singleFlightRecordData.real_speed + ' km/h' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    规划距离: <span>{{ singleFlightRecordData.total_mileage + ' km' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    实际距离: <span>{{ singleFlightRecordData.real_distance + ' km' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    平台载重效能: <span>{{ '0' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    投送速度效能: <span>{{ '0' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    飞行正确性效能: <span>{{ '0' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    综合效能指标: <span>{{ '0' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    单位重量单位距离费用效能: <span>{{ '0' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    单位重量单位距离时间效能: <span>{{ '0' }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="map" id="flightRecordMap" v-if="dialogVisible">

            </div>
          </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deepCopy } from '@/utils/tools.js'
import { initMap, addLine, addPoint, removePoint, addHeadAndTailPoint } from '../../../assets/js/map/OlMapUtil'
import airspaceStyle from "../../../assets/js/map/airspaceStyle";
import { wgs84ToGcj02 } from "../../../assets/js/map/ConverseLngAndLa";
import * as olProj from "ol/proj";

export default {
  name: 'flightRecordManagement',
  data() {
    return {
      addPermission: null,
      // 存储搜索信息
      queryForm: {
        name: ''
      },
      // 存储 飞行记录 表格数据
      flightRecordTableData: [],
      // 定义 飞行记录 各列相关信息
      flightRecordTableColumnLists: [
        {
          prop: "local_id",
          label: "计划编号",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "flight_name",
          label: "计划名称",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "created_at",
          label: "创建时间",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "user_name",
          label: "任务筹划员",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "uas_serial_id",
          label: "飞机编号",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "airline_name",
          label: "航线名称",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
      ],
      // 存储单条飞行记录信息
      singleFlightRecordData: {},
      // 查看详情模态框 显示隐藏
      dialogVisible: false,
      // 当前页数
      current: 1,
      // 每页显示条数
      size: 6,
      // 总条数
      totalCount: 0,
      flightRecordMap: null,
      center: [104.06, 30.67],
      mapType: "hybrid", //地图类型([normal:街道图;hybrid:卫星图])
      // 航线点存储数组
      routeList: []
    }
  },
  created() {
    this.query()
  },
  mounted() {
    this.setGutterWidth();
  },
  methods: {
    // 搜索飞行记录信息 - 分页函数 - 每页显示条数改变触发的事件
    handleSizeChange(size) {
      this.size = size;
      this.query();
    },
    // 搜索飞行记录信息 - 分页函数 - 页码改变触发的事件
    handleCurrentChange(current) {
      this.current = current;
      this.query();
    },
    // 查询 获取 飞行记录信息
    query() {
      this.getRequest(
        "/uav-task-server/flight/getFlightListForFlightManage.do?"
        + "pagesize=" + this.size 
        + "&currentpage=" + this.current
        + "&keyword=" + this.queryForm.name
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.flightRecordTableData = deepCopy(res.data.list)
            } else {
              this.$data.totalCount = 0;
              this.$data.flightRecordTableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch(() => {});
    },
    // 查看单条飞行记录详细信息
    seeDetailHandle(row) {
      this.querySingleFlightRecordDetailInfo(row.id)
      this.dialogVisible = true;
    },
    // 查询单条飞行记录详细信息
    querySingleFlightRecordDetailInfo(id) {
      this.getRequest(
          "/uav-task-server/flight/getFlightDetailForFlightManage.do?flightId=" + id
        ).then((res) => {
          if(res.status === 200) {
            res = res.data
            if (null != res && 0 == res.code) {
              this.singleFlightRecordData = deepCopy(res.data)
              const waypoints = res.data.task_coordinate_waypoints.split(";");
              // const points = (this.$data.tempAirlinePoints = []);
              const points = []
              waypoints.forEach((point) => {
                const pointArr = point.split(",");
                points.push({
                  lon: parseFloat(parseFloat(pointArr[1]).toFixed(6)),
                  lat: parseFloat(parseFloat(pointArr[2]).toFixed(6)),
                  alt: parseFloat(pointArr[4]),
                  rAlt: parseFloat(pointArr[3]),
                  command: "航点",
                });
              });
              this.$data.routeList = points
              const centerNum = Math.floor(this.$data.routeList.length / 2)
              this.center = [this.$data.routeList[centerNum].lon, this.$data.routeList[centerNum].lat]
              this.flightRecordMapHandle()
            }
          }
        })
    },
    // 飞行轨迹
    flightRecordMapHandle() {
       this.flightRecordMap = initMap(
          'flightRecordMap',
          this.center, 
          this.mapType
        )
        this.showPolyline()
    },
    showPolyline() {
      const points = [];
      const routePoints = [];
      const routeList = this.$data.routeList;
      const flightRecordMap = this.$data.flightRecordMap;
      const pointIds = this.$data.pointIds;
      const newPointIds = (this.$data.pointIds = []);
      let routeLayer = this.$data.routeLayer;
      const polyLineId = this.$data.polyLineId;
      if (!this.isEmptyArray(routeList)) {
        for (let index = 0; index < routeList.length; index++) {
          const point = routeList[index];
          routePoints.push(this.toMercatorPoint(point.lon, point.lat));
          points.push({
            id: index,
            longtitude: point.lon,
            latitude: point.lat,
          });
          newPointIds.push(index);
        }
      }
      //移除航点和航迹
      if (!this.isEmptyArray(pointIds)) {
        removePoint(flightRecordMap, pointIds);
      }
      if (null != routeLayer) {
        flightRecordMap.removeLayer(routeLayer);
        routeLayer = null;
      }
      //绘制航点和航迹
      if (null == routeLayer) {
        this.$data.routeLayer = addLine(
          flightRecordMap,
          { id: polyLineId },
          routePoints,
          airspaceStyle.flightRecordRouteStyle
        );
      }
      if (!this.isEmptyArray(points)) {
        addHeadAndTailPoint(flightRecordMap, points, airspaceStyle.flightRecordRouteStartPointStyle, airspaceStyle.flightRecordRouteEndPointStyle);
      }
    },
    
    //Google坐标转换为墨卡托坐标
    toMercatorPoint(lng, lat) {
      let coordinate = wgs84ToGcj02(lng, lat); //wgs84 经纬度处理
      return olProj.fromLonLat(coordinate); //转换后的经纬度转WEB墨卡托坐标
    },
    // 关闭按钮事件
    closeDetailHandle() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
  @import "../../../assets/css/admin/flightRecordManagement.css";
</style>

<style>
/* 隐藏地图放大缩小按钮 */
  #flightRecordMap .ol-zoom {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/management/flightRecordManagement.vue